// extracted by mini-css-extract-plugin
var _1 = "kiFgaSPpOy";
var _2 = "uWI244roVi";
export { _1 as "disabled", _2 as "root" }
